import { MapRequestResponderStatus } from '@/api/klip-api.proxy';
import { MapRequestExtendedResponderData } from "@/app/shared/components/kl-maprequest-una-table/kl-maprequest-una-table";
import {escape} from "html-escaper";

export const ERROR_STATUSES = [
    MapRequestResponderStatus.Assigned,
    MapRequestResponderStatus.Confirmed,
    MapRequestResponderStatus.NotAnswered,
];

export const SUCCESS_STATUSES = [
    MapRequestResponderStatus.Responded,
    MapRequestResponderStatus.NotInvolved,
];

export function parseResponderTitle(responder: MapRequestExtendedResponderData): string {
    const name = `<strong>${escape(responder.name)}</strong>`;
    const zone = responder.zoneName ? `&nbsp;- ${escape(responder.zoneName)}` : '';
    const title = `${name}${zone}`;

    if (responder.isKlimZone || responder.klim) {
        const klimLogo = '<img src="/img/logo-klim.svg" class="klim-pictogram" alt="Voor KLIM-leden geldt een antwoordtermijn van 15 werkdagen." />';
        return `${klimLogo}${title}`;
    }

    return title;
}

export function isResponderError(status: MapRequestResponderStatus): boolean {
    return ERROR_STATUSES.includes(status);
}

export function isResponderSuccess(status: MapRequestResponderStatus): boolean {
    return SUCCESS_STATUSES.includes(status);
}
